// extracted by mini-css-extract-plugin
export var phone = "_54-0";
export var phoneDragging = "_54-1";